import React from 'react';

function Component() {
  return (
    <div className={"text-center p-3 h-100 bg-white overflow-hidden rounded-3 border shadow-sm"}>
      <span className={"d-inline-block rounded-circle h-58 w-58 border skeleton mb-2"}/>
      <div className={"skeleton border rounded-2 mb-2"}/>
      <div className={"skeleton border rounded-2"}/>
    </div>
  );
}

export default Component;